<template>
  <div class="layout">
    <br><br>
    <el-input style="width: 70%" v-model="user.name"></el-input>
    <br><br>
    <el-input style="width: 70%" v-model="user.phone"></el-input>
    <br><br>
    <el-input style="width: 70%" v-model="user.birth"></el-input>
    <br><br>
    <el-input style="width: 70%" v-model="user.point"></el-input>
    <br><br>
    <el-button type="primary" icon="el-icon-refresh-right" @click="refresh"></el-button>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      user: {
        name: '',
        phone: '',
        birth: '',
        point: ''
      }
    };
  },
  mounted() {
    liff.init({ liffId: '1654689729-9gg0Pl3L' }).then(() => {
      liff.getProfile().then((_profile) => {
        if (_profile) {
          this.user.name = _profile.displayName;
        }
      })
      .catch((e) => {
      })
    })
    .catch((e) => {
    })
    // const user = this.$route.query.user ? this.$route.query.user : '';
    // if (user) {
    //   document.cookie = `user=${user}; max-age=2592000; path=/`;
    //   this.getAESData({ content: user }).then((res) => {
    //     this.user = res.data.result;
    //   });
    //   this.$router.push('/profile');
    // }
    // else {
    //   const cookieUser = this.getCookieByName('user');
    //   this.getAESData({ content: cookieUser }).then((res) => {
    //     this.user = res.data.result;
    //   });
    // }
  },
  methods: {
    ...mapActions({
      getAESData: 'getAESData'
    }),
    refresh() {
      window.location.reload()
    },
    parseCookie() {
      var cookieObj = {};
      var cookieAry = document.cookie.split(';');
      var cookie;
      for (var i=0, l=cookieAry.length; i<l; ++i) {
        cookie = cookieAry[i];
        cookie = cookie.split('=');
        cookieObj[cookie[0]] = cookie[1];
      }
      return cookieObj;
    },
    getCookieByName(name) {
      var value = this.parseCookie()[name];
      if (value) {
        value = decodeURIComponent(value);
      }
      return value;
    }
  }
}

</script>